module.exports = __webpack_public_path__ + "img/ring_r_skip_null_null@3x.f5741443.png";